import { useCallback, useEffect, useRef, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import { useSelector } from "react-redux";
import { GET_TIME_ZONE } from "../../Model/HomeModel";
import Styles from "./Purchases.module.css";
import PackageCard from "../../Components/PackageCard";
import Styles2 from "../Home/Home.module.css";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import Slider from "react-slick";
import { Package_List } from "../../Action/PacakgeAction";
import { useDispatch } from "react-redux";
import Enroll from "../Home/Enroll";
export default function MobilePurcahses() {
  const [SideOpener, setSideOpner] = useState(false);
  const [ActiveOrder, setActiveOrder] = useState(-1);
  const [CourseId, setCourseId] = useState("");
  const [EnrollActive, setEnrollActive] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { OrdersRec } = useSelector((s) => s.ListOrdersReducer);
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  const dispatch = useDispatch();
  const Mobile_Screen = window.innerWidth;
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );
  const BrowsePackageRef = useRef();
  const BrowsePacakgesettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow:
      Mobile_Screen <= 480
        ? 1
        : Mobile_Screen <= 780
        ? PackageRec?.length >= 2
          ? 2
          : 1
        : PackageRec?.length >= 2
        ? 2
        : PackageRec?.length == 2
        ? 2
        : 1,
    slidesToScroll: 1,
  };
  const getRotation = (index) => {
    const pos = index - currentSlide;
    if (pos === -2) return "rotate(-5deg)";
    if (pos === -1) return "rotate(-2.5deg)";
    if (pos === 0) return "rotate(0deg)";
    if (pos === 1) return "rotate(2.5deg)";
    if (pos === 2) return "rotate(5deg)";
    return "rotate(0deg)";
  };
  useEffect(() => {
    if (OrdersRec) {
      setTimeout(() => {
        setActiveOrder(0);
      }, 1000);
    }
  }, [OrdersRec]);

  const get_Packages = useCallback(() => {
    dispatch(Package_List({ page_size: 10, page_no: 1 }, "MainPackages"));
  }, [dispatch]);

  useEffect(() => {
    get_Packages();
  }, [get_Packages]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="Mobile_View_css">
        {EnrollActive ? (
          <Enroll
            setEnrollActive={setEnrollActive}
            Package_Id={EnrollActive}
            courseId={CourseId}
          />
        ) : (
          ""
        )}
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Purchases" />
        <div className="main-content">
          <MobileHeaderSection Page="Purchases" OpenSideMenu={OpenSideMenu} />

          <section style={{ padding: "20px 20px" }}>
            <div className="calendar-header">
              <h3>All Order List</h3>
            </div>
            <div>
              {OrdersRec ? (
                OrdersRec?.map((el, i) => (
                  <div
                    className={
                      ActiveOrder == i ? "order-card active" : "order-card"
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveOrder(i);
                    }}
                    key={el?._id}
                  >
                    <div className="order-top">
                      <span style={{ display: "flex", alignItems: "center" }}>
                        #Order Id:
                        <span className="order-id">{el?._id}</span>
                      </span>

                      <span>
                        {GET_TIME_ZONE(el?.createdAt).replace("at", " | ")}
                      </span>
                    </div>

                    <div className="order-bottom">
                      <span className="amount">₹ {el?.Amount}</span>
                      <span
                        className={`status ${el?.transactionStatus?.toLowerCase()}`}
                      >
                        {el?.transactionStatus}
                      </span>
                    </div>
                    <div
                      className={
                        ActiveOrder == i
                          ? "order-details active"
                          : "order-details"
                      }
                    >
                      <div className="detail-line">
                        Payment Method: {el?.transactionDetails?.paymentMethod}
                      </div>
                      {/* <div className="detail-line">Bank Ref ID: 84939383838</div> */}
                      <div className="detail-line">
                        Transaction ID: {el?._id}
                      </div>
                      <div className="detail-line">
                        Status:{" "}
                        {el?.transactionStatus?.toLowerCase() == "success"
                          ? "Payment received successfully."
                          : el?.transactionStatus?.toLowerCase()}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  <div className={Styles.no_notification_box}>
                    <img
                      src="/assets/image/No-Notification.png"
                      alt="No Notification Icon"
                    />
                    <div className={Styles.no_notification_text}>
                      No orders found. Start your order by selecting a package
                      below.
                    </div>
                  </div>
                  <section
                    style={{ background: "#f4f9ff", paddingBottom: "60px" }}
                  >
                    <div style={{ margin: "30px" }}>
                      <div className={Styles.Browse_Package_Section}>
                        <div>
                          {" "}
                          <h1 className={Styles.Heading}>
                            <span className="Font_Rajdhani">
                              Browse Courses{" "}
                            </span>
                          </h1>
                          {/* <p>
                    In this free interactive webinar, our IELTS expert will help
                    us be ready to answer
                    <br /> a range of common questions types for Part 1 of the
                    Speaking Test.
                  </p>{" "} */}
                        </div>
                        <div className={Styles.Browse_Package_Scroller}>
                          <div
                            onClick={() =>
                              BrowsePackageRef?.current?.slickPrev()
                            }
                          >
                            <FaCircleArrowLeft />
                          </div>
                          <div
                            onClick={() =>
                              BrowsePackageRef?.current?.slickNext()
                            }
                          >
                            {" "}
                            <FaCircleArrowRight />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ margin: "0 20px" }}>
                      <Slider
                        ref={BrowsePackageRef}
                        style={{ width: "100%" }}
                        {...BrowsePacakgesettings}
                      >
                        {PackageRec?.map((el, index) => (
                          <div
                            key={index}
                            // className="slide"
                            style={{
                              transform: getRotation(index),
                              transition: "transform 0.3s ease",
                            }}
                          >
                            <PackageCard
                              setEnrollActive={setEnrollActive}
                              EnrollActive={EnrollActive}
                              setCourseId={setCourseId}
                              el={el}
                              Styles={Styles2}
                            />
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </section>
                </>
              )}
            </div>
          </section>
          <MobileBottomMenu
            Page="
Purchases"
          />
        </div>
      </div>
    </>
  );
}
